import { render, staticRenderFns } from "./story-list.vue?vue&type=template&id=0aa779d6&"
import script from "./story-list.vue?vue&type=script&lang=js&"
export * from "./story-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports